import {
  FETCH_PENDING_REQUEST_COUNT_REQUEST,
  FETCH_PENDING_REQUEST_COUNT_SUCCESS,
  FETCH_PENDING_REQUEST_COUNT_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  pendingRequests: 0,
  error: null,
};

const fetchPendingRequestCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PENDING_REQUEST_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PENDING_REQUEST_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        pendingRequests: action.payload?.pendingRequests ?? 0,
        error: null,
      };
    case FETCH_PENDING_REQUEST_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fetchPendingRequestCountReducer;
